// @ts-nocheck
import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Tooltip from "@insite/mobius/Tooltip";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InfosBox, { InfosBoxProps } from "@store/Library/Components/Toolkit/InfosBox";
import { ProductImageStyles } from "@store/Overrides/Components/ProductImage";
import ReturnPolicy from "@store/Library/Components/Icons/ReturnPolicy";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import React, { useContext } from "react";
import { css, ThemeProps, withTheme } from "styled-components";

const enum fields {
    showReturnPolicy = "showReturnPolicy",
    showDescription = "showDescription",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.showReturnPolicy]: boolean;
        [fields.showDescription]: boolean;
    };
}

type Props = OwnProps & ThemeProps<BaseTheme>;

export interface ScratchAndDentLabelStyles {
    widgeTitle?: TypographyProps;
    productImageStyles?: ProductImageStyles;
    returnPolicyMessageInfosBox?: InfosBoxProps;
    returnPolicyMessageHeading?: TypographyProps;
    returnPolicyMessageText?: TypographyProps;
    descriptionText?: TypographyProps;
}

export const scratchAndDentLabelStyles: ScratchAndDentLabelStyles = {
    widgeTitle: {
        color: "text.main",
        as: "strong",
    },
    returnPolicyMessageInfosBox: {
        extendedStyles: {
            wrapper: {
                css: spacingStyles(pxToRem(15), null),
            },
            color: "text",
            backgroundColor: "primary.contrast",
            icon: {
                src: ReturnPolicy,
            },
            border: {
                color: "warning",
                radius: "5",
                style: "solid",
                width: "2",
            },
        },
    },
    returnPolicyMessageHeading: {
        as: "p",
        weight: "bold",
    },
    returnPolicyMessageText: {
        as: "p",
    },
    descriptionText: {
        as: "p",
        css: css`
            display: block;
            margin-bottom: ${pxToRem(15)};
        `,
    },
};

const styles = scratchAndDentLabelStyles;
const ScratchAndDentLabel = ({ fields }: Props) => {
    const { product } = useContext(ProductContext);
    if (!product.properties.isScratchAndDent && product.properties.isScratchAndDent !== "True") {
        return null;
    }

    return (
        <>
            <Typography {...styles.widgeTitle}>{translate("Scratch and dent product")}</Typography>
            <Tooltip text={translate("Those products are final sale.")} />
            {fields.showDescription && product.properties.sndDescription && (
                <Typography {...styles.descriptionText}>
                    {translate("Description:")} {product.properties.sndDescription}
                </Typography>
            )}
            {fields.showReturnPolicy && (
                <InfosBox data-test-selector="returnPolicy_Message" {...styles.returnPolicyMessageInfosBox}>
                    <Typography {...styles.returnPolicyMessageHeading}>
                        {translate("returnPolicyMessageHeading")}
                    </Typography>
                    <Typography {...styles.returnPolicyMessageText}>{translate("returnPolicyMessageText")}</Typography>
                </InfosBox>
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: withTheme(ScratchAndDentLabel),
    definition: {
        displayName: "Scratch And Dent Label",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
        fieldDefinitions: [
            {
                name: fields.showReturnPolicy,
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
            {
                name: fields.showDescription,
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
